import moment from 'moment'

function timeDescription(timestamp: number): string {
  let date = moment.unix(timestamp).unix()
  const now = moment().unix() * 1000
  const days = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  if (date.toString().length === 10) {
    date *= 1000
  }

  const dateTime = new Date(date)

  const diff = now - date

  if (diff < 0) {
    return 'Now'
  }

  if (diff < 60000) {
    return `${(diff / 1000).toFixed(0)}s`
  }

  if (diff < 3600000) {
    return `${Math.floor(diff / 60 / 1000).toFixed(0)}m`
  }

  if (diff < 86400000) {
    return `${Math.floor(diff / 3600 / 1000).toFixed(0)}h`
  }

  if (diff < 604800000) {
    return `${Math.floor(diff / 86400 / 1000).toFixed(0)}d`
  }

  // if (diff < 2592000000) {
  //     return `${days[dateTime.getMonth()]} ${dateTime.getDate()}`
  // }

  // if (diff < 31536000000) {
  //     return `${days[dateTime.getMonth()]} ${dateTime.getDate()}, ${dateTime.getFullYear()}`
  // }

  return `${days[dateTime.getMonth()]} ${dateTime.getDate()}, ${dateTime.getFullYear()}`
}

export default timeDescription
